import { useDispatch, useSelector } from "react-redux";
import CustomisedButton from "../../../components/button/button";
import { changeRouteType, getNextInnerState, getpervInnerState } from "../../../redux/handleBackBtn/handleBackBtnSlice";
import { title } from "process";
import { useEffect, useState } from "react";
import { setHeaderTitle } from "../../../redux/headerTitle/headerTitleSlice";
import { getpervStateTab } from "../../../redux/loansTab/loansTabSlice";
import GuarantorCard from "../../../components/card/guarantorCard/guarantorCard";
import { useMutation, useQueryClient } from "react-query";
import { CheckCompletion, getGuarantors } from "../../../services/guarantor.service";
import { CheckCompletionResponse, IGetGuarantorChequeRequest, IGetGuarantorsResponse } from "../../../models/guarantor.model";
import GuarantorEditCard from "../../../components/card/guarantorCard/guarantorEditCard";
import { IGuaranteeInfo } from "../../navigationButtonComponents/loansTab/loanDetail/guarantee/IGuaranteeTab";
import { IGuarantorContainer } from "../../navigationButtonComponents/guarantorContainer/TGuarantorContainer";
import { setGuarantorInfo } from '../../../redux/guarantor/guarantorInfoSlice'
import { useAppBar } from "../../../components/appBar/appBarContext";
import { DOCUMENT_TYPES, GUARANTOR_MOBILE, GUARANTOR_REQUIRED_OTP, INCOME_RANGE, INQUIRY_REQUIRED_OTP, INQUIRY_RESULT } from "../../../config/cacheKey";
import { getFormRejectReasons } from "../../../services/registration.service";
import { IGetFormRejectReasonsResponse } from "../../../models/registration.model";
import { IDocumentTypeHints } from "../../../models/basicInformation.model";
import { IInquiryResponse, IInquiryResult, TotalInquiryRequest } from "../../../models/inquiry.model";
import { v4 as uuid } from 'uuid';
import { TotalInquiry } from "../../../services/inquiry.service";
import { RootState } from "../../../redux/store";
import GuarantorDeleteCard from "../../../components/card/guarantorCard/guarantorDeleteCard";
import { ApiResultModel } from "../../../models/common.model";
import GuarantorSkeleton from "./guarantorSkeleton";
import CustomisedErrorCard from "../../../components/card/errorCard";

const Guarantor = ({ setStep, referenceKey, setInnerState }: any) => {
    const dispatch = useDispatch();
    const { setHeader } = useAppBar();
    const [data, setData] = useState<IGetGuarantorsResponse[]>([]);
    const [isDelete, setIsDelete] = useState(false);
    const [isEditDocument, setIsEditDocument] = useState(false);
    const [isEditCheque, setIsEditCheque] = useState(false);
    const queryClient = useQueryClient();
    const randomKeyForDispatch = Math.random();
    const [rejectReasons, setRejectReasons] = useState<string[]>([]);
    const [rejectReasonsKey, setRejectReasonsKey] = useState<string[]>([]);
    const [checkBySetad, setCheckBySetad] = useState<string[]>([]);
    const [formCheckBySetad, setFormCheckBySetad] = useState(false);
    const [reject, setReject] = useState(false);
    const [entityRejectReasons, setEntityRejectReasons] = useState<string[]>([]);
    const [documentTypeRejectReasons, setDocumentTypeRejectReasons] = useState<string[]>([]);
    const [isCheckedBySetad, setIsCheckedBySetad] = useState(false);

    const guarantorKey = useSelector(
        (state: RootState) => state.guarantorInfo.guarantorKey
    );
    const [inquiryRequiredOtp, setInquiryRequiredOtp] = useState(queryClient.getQueryData(GUARANTOR_REQUIRED_OTP) as IInquiryResult);

    useEffect(() => {
        GetGuarantorsMutate({ referenceKey: referenceKey })
        GetRejectReasonsResidenceMutate({
            referenceKey: referenceKey!,
            form: 'Guarantors'
        });
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'forms' + randomKeyForDispatch }));
        queryClient.setQueryData(GUARANTOR_MOBILE, null);
        queryClient.setQueryData(INCOME_RANGE, '');
    }, []);

    useEffect(() => {
        setIsDelete(false);
        if (isDelete === true) {
            GetGuarantorsMutate({ referenceKey: referenceKey })
        }
    }, [isDelete])
    useEffect(() => {
        if (isEditDocument === true) {
            setIsEditDocument(false);
            setInnerState!('guarantorCompletion');
        }
    }, [isEditDocument])
    useEffect(() => {
        if (isEditCheque === true) {
            setIsEditCheque(false);
            setInnerState!('guarantorRegister');
        }
    }, [isEditCheque])

    const { mutate: CheckCompletionMutate } = useMutation(
        CheckCompletion,
        {
            onSuccess: (data: CheckCompletionResponse) => {
                if (data) {
                    setIsCheckedBySetad(data.isCheckedBySetad);
                }
            },
        }
    );
    const handleContinue = () => {
        dispatch(getNextInnerState({ nextInnerState: `formLists ${randomKeyForDispatch} ` }));
    }

    const handleGuarantor = (guarantorTitle: string, guarantorKey: string) => {
        dispatch(setGuarantorInfo({ guarantorTitle, guarantorKey }));
        setInnerState!('guarantorInfo');
    };
    const request = {} as TotalInquiryRequest;

    const { mutate: GetGuarantorsMutate, isLoading: LoadingGetGuarantor } = useMutation(
        getGuarantors,
        {
            onSuccess: (data: IGetGuarantorsResponse[]) => {
                if (data) {
                    setData(data);
                    let checkComplete = {} as IGetGuarantorChequeRequest;
                    checkComplete.guarantorKey = data[0].key;
                    checkComplete.referenceKey = referenceKey!;
                    CheckCompletionMutate(checkComplete);
                }
            },
        }
    );
    const { mutate: GetRejectReasonsResidenceMutate } = useMutation(
        getFormRejectReasons,
        {
            onSuccess: (data: IGetFormRejectReasonsResponse[]) => {
                if (data) {
                    let reject: any[] = [];
                    let entityReject: any[] = [];
                    let documentTypeReject: any[] = [];
                    let rejectKey: any[] = [];
                    let setad: any[] = [];
                    data.map((item: any) => {
                        if (item.rejectReasons!.length > 0) {
                            reject.push(item.rejectReasons);
                            rejectKey.push(item.guarantorKey);
                        }
                        if (item.checkBySetad === true) {
                            setad.push(item.guarantorKey);
                            setFormCheckBySetad(true);
                        }
                        if (item.entityRejectReasons.length > 0) {
                            entityReject.push(item.guarantorKey);
                        }
                        if (item.documentTypeRejectReasons.length > 0) {
                            documentTypeReject.push(item.guarantorKey);
                        }
                        if ((item.entityRejectReasons.length > 0 || item.documentTypeRejectReasons.length > 0) && item.checkBySetad === false) {
                            setReject(true);
                        }
                    }
                    )
                    setRejectReasons(reject);
                    setRejectReasonsKey(rejectKey);
                    setEntityRejectReasons(entityReject);
                    setDocumentTypeRejectReasons(documentTypeReject);
                    setCheckBySetad(setad);
                }
            },
        }
    );

    const setChildValue = (key: string) => {
        request.referenceKey = referenceKey!;
        request.guarantorKey = key;
        InquiryValidationOTPMutation(request);
    }
    const { mutateAsync: InquiryValidationOTPMutation, isLoading } = useMutation(TotalInquiry, {
        onSuccess: (data: ApiResultModel<IInquiryResponse>) => {
            if (data) {
                if (data.data.requiredOtpValidation) {
                    setInnerState!('otp');
                    queryClient.setQueryData(INQUIRY_REQUIRED_OTP, data.data.requiredOtpValidation);
                    // setInquiryRequiredOtp(data.requiredOtpValidation);
                    // setOtp('');
                }
                else if (data.data.inquiries.length > 0) {
                    setInnerState!('guarantorInquiryResult')
                    queryClient.setQueryData(INQUIRY_RESULT, data.data.inquiries);
                }
                else {
                    setStep(uuid);
                }

            }
        },
        onError: () => { },
    });
    if (LoadingGetGuarantor) {
        return <GuarantorSkeleton />
    }
    return (
        <>
            <div className="container-height-drawer">
                <div className='content-container'>
                    <div className='drawer-content'>
                        {/* {rejectReasons.length > 0 ?
                            <CustomisedErrorCard titleList={rejectReasons} />
                            : ""
                        } */}
                        {data.map((item: any) =>

                            <div >

                                {/* onClick={() => { handleGuarantor(item.title, item.key) }} */}
                                {
                                    (item.isInquiryCompleted === false && item.key !== null)
                                        ?
                                        <GuarantorDeleteCard
                                            title={item.title}
                                            firstName={item.firstName}
                                            lastName={item.lastName}
                                            nationalCode={item.nationalCode}
                                            backgroundColor={'#FFF'}
                                            referenceKey={referenceKey}
                                            setChildValue={setChildValue}
                                            guarantorKey={item.key}
                                            setIsDelete={setIsDelete}
                                            mobileNumber={item.mobileNumber}
                                        />
                                        : (item.isInquiryCompleted === true && item.key !== null) ?
                                            <GuarantorEditCard
                                                title={item.title}
                                                firstName={item.firstName}
                                                lastName={item.lastName}
                                                nationalCode={item.nationalCode}
                                                backgroundColor={'#FFF'}
                                                referenceKey={referenceKey}
                                                guarantorKey={item.key}
                                                setIsEditDocument={setIsEditDocument}
                                                mobileNumber={item.mobileNumber}
                                                setIsEditCheque={setIsEditCheque}
                                                setIsDelete={setIsDelete}
                                                isAdditionalInfoCompleted={item.isAdditionalInfoCompleted}
                                                isCompleted={item.isCompleted}
                                                checkBySetad={checkBySetad.filter((key: any) => key === item.key)}
                                                entityRejectReasons={entityRejectReasons.filter((key: any) => key === item.key)}
                                                rejectReasonsKey={rejectReasonsKey.filter((key: any) => key === item.key)}
                                                documentTypeRejectReasons={documentTypeRejectReasons.filter((key: any) => key === item.key)}
                                                formCheckBySetad={formCheckBySetad}
                                                isCheckedBySetad={isCheckedBySetad}

                                            />
                                            :
                                            <div onClick={() => { handleGuarantor(item.title, item.key) }}>
                                                <GuarantorCard title={item.title}
                                                    status={'در انتظار ثبت اطلاعات'}
                                                    id={item.id}
                                                    key={item.key}
                                                    borderColor={reject === true && item.isCompleted === false
                                                        ? 'primaryErrorColorLight' : undefined}
                                                />
                                            </div>
                                }
                            </div>
                        )}
                    </div>
                    <div className="py-5">
                        <CustomisedButton
                            title={'ادامه'}
                            disable={false}
                            onClick={handleContinue}
                            type="submit"
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Guarantor;
